export default { "columns":34,
 "image":"shrine-tileset.png",
 "imageheight":368,
 "imagewidth":544,
 "margin":0,
 "name":"shrine-tileset",
 "spacing":0,
 "tilecount":782,
 "tiledversion":"1.11.1",
 "tileheight":16,
 "tiles":[
        {
         "id":72,
         "type":"ground"
        }, 
        {
         "id":73,
         "type":"ground"
        }, 
        {
         "id":74,
         "type":"ground"
        }, 
        {
         "id":75,
         "type":"ground"
        }, 
        {
         "id":76,
         "type":"ground"
        }, 
        {
         "id":77,
         "type":"ground"
        }, 
        {
         "id":78,
         "type":"ground"
        }, 
        {
         "id":79,
         "type":"ground"
        }, 
        {
         "id":81,
         "type":"ground"
        }, 
        {
         "id":82,
         "type":"ground"
        }, 
        {
         "id":83,
         "type":"ground"
        }, 
        {
         "id":84,
         "type":"ground"
        }, 
        {
         "id":85,
         "type":"ground"
        }, 
        {
         "id":86,
         "type":"ground"
        }, 
        {
         "id":87,
         "type":"ground"
        }, 
        {
         "id":88,
         "type":"ground"
        }, 
        {
         "id":106,
         "type":"ground"
        }, 
        {
         "id":107,
         "type":"ground"
        }, 
        {
         "id":108,
         "type":"ground"
        }, 
        {
         "id":109,
         "type":"ground"
        }, 
        {
         "id":110,
         "type":"ground"
        }, 
        {
         "id":111,
         "type":"ground"
        }, 
        {
         "id":112,
         "type":"ground"
        }, 
        {
         "id":113,
         "type":"ground"
        }, 
        {
         "id":115,
         "type":"ground"
        }, 
        {
         "id":116,
         "type":"ground"
        }, 
        {
         "id":117,
         "type":"ground"
        }, 
        {
         "id":118,
         "type":"ground"
        }, 
        {
         "id":119,
         "type":"ground"
        }, 
        {
         "id":120,
         "type":"ground"
        }, 
        {
         "id":121,
         "type":"ground"
        }, 
        {
         "id":122,
         "type":"ground"
        }, 
        {
         "id":124,
         "type":"ground"
        }, 
        {
         "id":125,
         "type":"ground"
        }, 
        {
         "id":126,
         "type":"ground"
        }, 
        {
         "id":129,
         "type":"ground"
        }, 
        {
         "id":130,
         "type":"ground"
        }, 
        {
         "id":131,
         "type":"ground"
        }, 
        {
         "id":158,
         "type":"ground"
        }, 
        {
         "id":159,
         "type":"ground"
        }, 
        {
         "id":164,
         "type":"ground"
        }, 
        {
         "id":165,
         "type":"ground"
        }, 
        {
         "id":174,
         "type":"ground"
        }, 
        {
         "id":175,
         "type":"ground"
        }, 
        {
         "id":176,
         "type":"ground"
        }, 
        {
         "id":177,
         "type":"ground"
        }, 
        {
         "id":178,
         "type":"ground"
        }, 
        {
         "id":179,
         "type":"ground"
        }, 
        {
         "id":180,
         "type":"ground"
        }, 
        {
         "id":181,
         "type":"ground"
        }, 
        {
         "id":183,
         "type":"ground"
        }, 
        {
         "id":184,
         "type":"ground"
        }, 
        {
         "id":185,
         "type":"ground"
        }, 
        {
         "id":186,
         "type":"ground"
        }, 
        {
         "id":187,
         "type":"ground"
        }, 
        {
         "id":188,
         "type":"ground"
        }, 
        {
         "id":189,
         "type":"ground"
        }, 
        {
         "id":190,
         "type":"ground"
        }, 
        {
         "id":208,
         "type":"ground"
        }, 
        {
         "id":209,
         "type":"ground"
        }, 
        {
         "id":210,
         "type":"ground"
        }, 
        {
         "id":211,
         "type":"ground"
        }, 
        {
         "id":212,
         "type":"ground"
        }, 
        {
         "id":213,
         "type":"ground"
        }, 
        {
         "id":214,
         "type":"ground"
        }, 
        {
         "id":215,
         "type":"ground"
        }, 
        {
         "id":217,
         "type":"ground"
        }, 
        {
         "id":218,
         "type":"ground"
        }, 
        {
         "id":223,
         "type":"ground"
        }, 
        {
         "id":224,
         "type":"ground"
        }, 
        {
         "id":226,
         "type":"ground"
        }, 
        {
         "id":227,
         "type":"ground"
        }, 
        {
         "id":228,
         "type":"ground"
        }, 
        {
         "id":231,
         "type":"ground"
        }, 
        {
         "id":232,
         "type":"ground"
        }, 
        {
         "id":233,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":243
                }, 
                {
                 "duration":100,
                 "tileid":345
                }],
         "id":243
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":246
                }, 
                {
                 "duration":100,
                 "tileid":348
                }],
         "id":245
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":246
                }, 
                {
                 "duration":100,
                 "tileid":348
                }],
         "id":246
        }, 
        {
         "id":251,
         "type":"ground"
        }, 
        {
         "id":252,
         "type":"ground"
        }, 
        {
         "id":257,
         "type":"ground"
        }, 
        {
         "id":258,
         "type":"ground"
        }, 
        {
         "id":260,
         "type":"ground"
        }, 
        {
         "id":261,
         "type":"ground"
        }, 
        {
         "id":266,
         "type":"ground"
        }, 
        {
         "id":267,
         "type":"ground"
        }, 
        {
         "id":276,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":277
                }, 
                {
                 "duration":100,
                 "tileid":379
                }],
         "id":277,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":278
                }, 
                {
                 "duration":100,
                 "tileid":380
                }],
         "id":278,
         "type":"ground"
        }, 
        {
         "id":279,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":280
                }, 
                {
                 "duration":100,
                 "tileid":382
                }],
         "id":280,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":281
                }, 
                {
                 "duration":100,
                 "tileid":383
                }],
         "id":281,
         "type":"ground"
        }, 
        {
         "id":285,
         "type":"ground"
        }, 
        {
         "id":286,
         "type":"ground"
        }, 
        {
         "id":291,
         "type":"ground"
        }, 
        {
         "id":292,
         "type":"ground"
        }, 
        {
         "id":310,
         "type":"ground"
        }, 
        {
         "id":311,
         "type":"ground"
        }, 
        {
         "id":312,
         "type":"ground"
        }, 
        {
         "id":313,
         "type":"ground"
        }, 
        {
         "id":314,
         "type":"ground"
        }, 
        {
         "id":315,
         "type":"ground"
        }, 
        {
         "id":319,
         "type":"ground"
        }, 
        {
         "id":320,
         "type":"ground"
        }, 
        {
         "id":325,
         "type":"ground"
        }, 
        {
         "id":326,
         "type":"ground"
        }, 
        {
         "id":353,
         "type":"ground"
        }, 
        {
         "id":354,
         "type":"ground"
        }, 
        {
         "id":359,
         "type":"ground"
        }, 
        {
         "id":360,
         "type":"ground"
        }, 
        {
         "id":362,
         "type":"ground"
        }, 
        {
         "id":363,
         "type":"ground"
        }, 
        {
         "id":364,
         "type":"ground"
        }, 
        {
         "id":365,
         "type":"ground"
        }, 
        {
         "id":366,
         "type":"ground"
        }, 
        {
         "id":367,
         "type":"ground"
        }, 
        {
         "id":369,
         "type":"ground"
        }, 
        {
         "id":370,
         "type":"ground"
        }, 
        {
         "id":371,
         "type":"ground"
        }, 
        {
         "id":372,
         "type":"ground"
        }, 
        {
         "id":378,
         "type":"ground"
        }, 
        {
         "id":379,
         "type":"ground"
        }, 
        {
         "id":380,
         "type":"ground"
        }, 
        {
         "id":381,
         "type":"ground"
        }, 
        {
         "id":382,
         "type":"ground"
        }, 
        {
         "id":383,
         "type":"ground"
        }, 
        {
         "id":387,
         "type":"ground"
        }, 
        {
         "id":388,
         "type":"ground"
        }, 
        {
         "id":393,
         "type":"ground"
        }, 
        {
         "id":394,
         "type":"ground"
        }, 
        {
         "id":396,
         "type":"ground"
        }, 
        {
         "id":397,
         "type":"ground"
        }, 
        {
         "id":398,
         "type":"ground"
        }, 
        {
         "id":399,
         "type":"ground"
        }, 
        {
         "id":400,
         "type":"ground"
        }, 
        {
         "id":401,
         "type":"ground"
        }, 
        {
         "id":403,
         "type":"ground"
        }, 
        {
         "id":404,
         "type":"ground"
        }, 
        {
         "id":405,
         "type":"ground"
        }, 
        {
         "id":406,
         "type":"ground"
        }, 
        {
         "id":412,
         "type":"ground"
        }, 
        {
         "id":413,
         "type":"ground"
        }, 
        {
         "id":414,
         "type":"ground"
        }, 
        {
         "id":415,
         "type":"ground"
        }, 
        {
         "id":416,
         "type":"ground"
        }, 
        {
         "id":417,
         "type":"ground"
        }, 
        {
         "id":421,
         "type":"ground"
        }, 
        {
         "id":422,
         "type":"ground"
        }, 
        {
         "id":427,
         "type":"ground"
        }, 
        {
         "id":428,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":450
                }, 
                {
                 "duration":100,
                 "tileid":586
                }],
         "id":450
        }, 
        {
         "id":455,
         "type":"ground"
        }, 
        {
         "id":456,
         "type":"ground"
        }, 
        {
         "id":461,
         "type":"ground"
        }, 
        {
         "id":462,
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":477
                }, 
                {
                 "duration":100,
                 "tileid":613
                }],
         "id":477,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":478
                }, 
                {
                 "duration":100,
                 "tileid":614
                }],
         "id":478,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":480
                }, 
                {
                 "duration":100,
                 "tileid":616
                }],
         "id":480,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":481
                }, 
                {
                 "duration":100,
                 "tileid":617
                }],
         "id":481,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":483
                }, 
                {
                 "duration":100,
                 "tileid":619
                }],
         "id":483,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":484
                }, 
                {
                 "duration":100,
                 "tileid":620
                }],
         "id":484,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":486
                }, 
                {
                 "duration":100,
                 "tileid":622
                }],
         "id":486,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "animation":[
                {
                 "duration":100,
                 "tileid":487
                }, 
                {
                 "duration":100,
                 "tileid":623
                }],
         "id":487,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":489,
         "type":"ground"
        }, 
        {
         "id":490,
         "type":"ground"
        }, 
        {
         "id":491,
         "type":"ground"
        }, 
        {
         "id":492,
         "type":"ground"
        }, 
        {
         "id":493,
         "type":"ground"
        }, 
        {
         "id":494,
         "type":"ground"
        }, 
        {
         "id":495,
         "type":"ground"
        }, 
        {
         "id":496,
         "type":"ground"
        }, 
        {
         "id":498,
         "type":"ground"
        }, 
        {
         "id":499,
         "type":"ground"
        }, 
        {
         "id":500,
         "type":"ground"
        }, 
        {
         "id":501,
         "type":"ground"
        }, 
        {
         "id":502,
         "type":"ground"
        }, 
        {
         "id":503,
         "type":"ground"
        }, 
        {
         "id":505,
         "type":"ground"
        }, 
        {
         "id":506,
         "type":"ground"
        }, 
        {
         "id":507,
         "type":"ground"
        }, 
        {
         "id":508,
         "type":"ground"
        }, 
        {
         "id":511,
         "type":"ground"
        }, 
        {
         "id":512,
         "type":"ground"
        }, 
        {
         "id":514,
         "type":"ground"
        }, 
        {
         "id":515,
         "type":"ground"
        }, 
        {
         "id":517,
         "type":"ground"
        }, 
        {
         "id":518,
         "type":"ground"
        }, 
        {
         "id":520,
         "type":"ground"
        }, 
        {
         "id":521,
         "type":"ground"
        }, 
        {
         "id":523,
         "type":"ground"
        }, 
        {
         "id":524,
         "type":"ground"
        }, 
        {
         "id":525,
         "type":"ground"
        }, 
        {
         "id":526,
         "type":"ground"
        }, 
        {
         "id":527,
         "type":"ground"
        }, 
        {
         "id":528,
         "type":"ground"
        }, 
        {
         "id":529,
         "type":"ground"
        }, 
        {
         "id":530,
         "type":"ground"
        }, 
        {
         "id":532,
         "type":"ground"
        }, 
        {
         "id":533,
         "type":"ground"
        }, 
        {
         "id":534,
         "type":"ground"
        }, 
        {
         "id":535,
         "type":"ground"
        }, 
        {
         "id":536,
         "type":"ground"
        }, 
        {
         "id":537,
         "type":"ground"
        }, 
        {
         "id":539,
         "type":"ground"
        }, 
        {
         "id":540,
         "type":"ground"
        }, 
        {
         "id":541,
         "type":"ground"
        }, 
        {
         "id":542,
         "type":"ground"
        }, 
        {
         "id":545,
         "type":"ground"
        }, 
        {
         "id":546,
         "type":"ground"
        }, 
        {
         "id":548,
         "type":"ground"
        }, 
        {
         "id":549,
         "type":"ground"
        }, 
        {
         "id":551,
         "type":"ground"
        }, 
        {
         "id":552,
         "type":"ground"
        }, 
        {
         "id":554,
         "type":"ground"
        }, 
        {
         "id":555,
         "type":"ground"
        }, 
        {
         "id":566,
         "type":"ground"
        }, 
        {
         "id":567,
         "type":"ground"
        }, 
        {
         "id":570,
         "type":"ground"
        }, 
        {
         "id":571,
         "type":"ground"
        }, 
        {
         "id":600,
         "type":"ground"
        }, 
        {
         "id":601,
         "type":"ground"
        }, 
        {
         "id":604,
         "type":"ground"
        }, 
        {
         "id":605,
         "type":"ground"
        }, 
        {
         "id":607,
         "type":"platform"
        }, 
        {
         "id":608,
         "type":"platform"
        }, 
        {
         "id":609,
         "type":"platform"
        }, 
        {
         "id":610,
         "type":"platform"
        }, 
        {
         "id":613,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":614,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":616,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":-16
                            }, 
                            {
                             "x":16,
                             "y":0
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":16
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":617,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":619,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":620,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":622,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":-16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":16,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":623,
         "objectgroup":
            {
             "draworder":"index",
             "name":"",
             "objects":[
                    {
                     "height":0,
                     "id":1,
                     "name":"",
                     "polygon":[
                            {
                             "x":0,
                             "y":0
                            }, 
                            {
                             "x":16,
                             "y":16
                            }, 
                            {
                             "x":0,
                             "y":16
                            }],
                     "rotation":0,
                     "type":"",
                     "visible":true,
                     "width":0,
                     "x":0,
                     "y":0
                    }],
             "opacity":1,
             "type":"objectgroup",
             "visible":true,
             "x":0,
             "y":0
            },
         "type":"ground"
        }, 
        {
         "id":625,
         "type":"ground"
        }, 
        {
         "id":626,
         "type":"ground"
        }, 
        {
         "id":631,
         "type":"ground"
        }, 
        {
         "id":632,
         "type":"ground"
        }, 
        {
         "id":634,
         "type":"ground"
        }, 
        {
         "id":635,
         "type":"ground"
        }, 
        {
         "id":636,
         "type":"ground"
        }, 
        {
         "id":637,
         "type":"ground"
        }, 
        {
         "id":638,
         "type":"ground"
        }, 
        {
         "id":639,
         "type":"ground"
        }, 
        {
         "id":641,
         "type":"platform"
        }, 
        {
         "id":642,
         "type":"platform"
        }, 
        {
         "id":643,
         "type":"platform"
        }, 
        {
         "id":644,
         "type":"platform"
        }, 
        {
         "id":647,
         "type":"ground"
        }, 
        {
         "id":648,
         "type":"ground"
        }, 
        {
         "id":650,
         "type":"ground"
        }, 
        {
         "id":651,
         "type":"ground"
        }, 
        {
         "id":653,
         "type":"ground"
        }, 
        {
         "id":654,
         "type":"ground"
        }, 
        {
         "id":656,
         "type":"ground"
        }, 
        {
         "id":657,
         "type":"ground"
        }, 
        {
         "id":659,
         "type":"ground"
        }, 
        {
         "id":660,
         "type":"ground"
        }, 
        {
         "id":661,
         "type":"ground"
        }, 
        {
         "id":662,
         "type":"ground"
        }, 
        {
         "id":663,
         "type":"ground"
        }, 
        {
         "id":664,
         "type":"ground"
        }, 
        {
         "id":665,
         "type":"ground"
        }, 
        {
         "id":666,
         "type":"ground"
        }, 
        {
         "id":681,
         "type":"ground"
        }, 
        {
         "id":682,
         "type":"ground"
        }, 
        {
         "id":684,
         "type":"ground"
        }, 
        {
         "id":685,
         "type":"ground"
        }, 
        {
         "id":687,
         "type":"ground"
        }, 
        {
         "id":688,
         "type":"ground"
        }, 
        {
         "id":690,
         "type":"ground"
        }, 
        {
         "id":691,
         "type":"ground"
        }, 
        {
         "id":693,
         "type":"ground"
        }, 
        {
         "id":694,
         "type":"ground"
        }, 
        {
         "id":695,
         "type":"ground"
        }, 
        {
         "id":696,
         "type":"ground"
        }, 
        {
         "id":697,
         "type":"ground"
        }, 
        {
         "id":698,
         "type":"ground"
        }, 
        {
         "id":699,
         "type":"ground"
        }, 
        {
         "id":700,
         "type":"ground"
        }, 
        {
         "id":709,
         "type":"platform"
        }, 
        {
         "id":710,
         "type":"platform"
        }, 
        {
         "id":711,
         "type":"platform"
        }, 
        {
         "id":712,
         "type":"platform"
        }],
 "tilewidth":16,
 "type":"tileset",
 "version":"1.10"
};